var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcicibank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7267 10.3083C23.7872 0.321725 35.9922 -2.27012 40.8764 4.53672C45.7606 11.3435 41.468 25.1014 31.4074 35.088C21.3469 45.1485 9.14196 47.7366 4.1838 40.8558C-0.622764 33.9788 3.66986 20.2911 13.7267 10.3083Z",
    fill: "#F06321"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3855 4.98007C19.2762 5.79349 18.167 6.7548 17.0578 7.79376C8.25443 16.5195 4.55335 28.5026 8.91994 34.4961C13.4307 40.4858 24.2307 38.2674 33.2559 29.464C38.1401 24.7314 41.3938 19.2556 42.7248 14.1532C43.0946 10.3819 42.577 7.05059 40.8762 4.53639C37.0309 -0.787801 28.7452 -0.347819 20.3855 4.98007Z",
    fill: "#AE282E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1081 6.08976V6.3116C33.0343 7.5687 32.2947 9.12158 30.9636 10.4526C28.9671 12.3753 26.3049 13.1147 25.192 12.0092C23.9349 10.8261 24.6781 8.23422 26.6747 6.16371C28.7452 4.16713 31.4073 3.50161 32.5165 4.68476C32.8863 5.0545 33.1081 5.49818 33.1081 6.08976ZM25.4176 40.0426C20.6813 43.592 15.8007 45.3705 11.0645 44.631C13.061 44.7049 14.6915 42.4828 16.0226 39.5249C17.3536 36.4931 18.0931 33.6831 18.7586 31.0173C19.7199 26.8023 19.7939 23.8445 19.2763 23.1789C18.4628 22.14 16.6881 22.3655 14.6139 23.5487C13.5786 24.1402 12.2476 23.7705 13.8042 21.8479C15.431 19.9253 21.7165 15.3368 23.9349 14.5974C26.4528 13.9318 29.2628 14.8932 28.3015 17.6292C27.6323 19.6258 18.9066 42.4089 25.4176 40.0426Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcicibank);
export default __webpack_public_path__ + "static/media/icicibank.a5d948718457322e82ff520eed86b8df.svg";
export { ForwardRef as ReactComponent };